import CryptoJS from "crypto-js";

const ENCRYPTION_KEY =
  "5b7qPgo/T4vV0gD+/M4PWpsy6qPpxBZN5/Gj7dqv8GjgvTbZQSzn5UL9gyzHAleR";

export function setLocalStorage(key, data) {
  try {
    const stringData = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      stringData,
      ENCRYPTION_KEY
    ).toString();
    localStorage.setItem(key, encryptedData);
  } catch (error) {
  }
}

export function getLocalStorage(key) {
  try {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;

    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    return null;
  }
}

export function clearAllLocalStorage() {
  localStorage.clear();
}

export function clearSpecificLocalStorage(keys = []) {
  keys.forEach((key) => localStorage.removeItem(key));
}
